import React from 'react';
import { Loader, Card } from 'semantic-ui-react';
import { string, bool, arrayOf, shape, func } from 'prop-types';

import StationItem from './StationItem';
import StationsNotFound from './StationsNotFound';

const Stations = ({
  terms,
  loadingStations,
  playStation,
  pauseStation,
  isPlaying,
  match,
  filteredStations,
  currentlyPlaying,
  showModal
}) =>
  loadingStations ? (
    <Loader active>Loading...</Loader>
  ) : (
    <Card.Group centered className="main-feed">
      {filteredStations.length > 0 ? (
        filteredStations.map(item => (
          <StationItem
            terms={terms}
            key={item.name}
            station={item}
            match={match}
            playStation={playStation}
            pauseStation={pauseStation}
            isPlaying={isPlaying && item.key === currentlyPlaying.key}
            showModal={showModal}
          />
        ))
      ) : (
        <StationsNotFound terms={terms} match={match} />
      )}
    </Card.Group>
  );

Stations.propTypes = {
  terms: arrayOf(string).isRequired,
  loadingStations: bool.isRequired,
  playStation: func.isRequired,
  pauseStation: func.isRequired,
  isPlaying: bool.isRequired,
  match: shape().isRequired,
  filteredStations: arrayOf(shape()).isRequired,
  currentlyPlaying: shape().isRequired,
  showModal: func.isRequired
};

export default Stations;
